/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MachinePart
 */
export interface MachinePart {
    /**
     * 
     * @type {string}
     * @memberof MachinePart
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MachinePart
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof MachinePart
     */
    machineId?: string;
    /**
     * 
     * @type {string}
     * @memberof MachinePart
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MachinePart
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof MachinePart
     */
    partNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof MachinePart
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MachinePart
     */
    updatedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof MachinePart
     */
    active?: boolean;
}

/**
 * Check if a given object implements the MachinePart interface.
 */
export function instanceOfMachinePart(value: object): value is MachinePart {
    return true;
}

export function MachinePartFromJSON(json: any): MachinePart {
    return MachinePartFromJSONTyped(json, false);
}

export function MachinePartFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachinePart {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'partNumber': json['partNumber'] == null ? undefined : json['partNumber'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function MachinePartToJSON(value?: MachinePart | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'type': value['type'],
        'machineId': value['machineId'],
        'name': value['name'],
        'description': value['description'],
        'partNumber': value['partNumber'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'active': value['active'],
    };
}

